import { GridColDef } from "@mui/x-data-grid";

export const vehicleTestsColumns: GridColDef[] = [
  {
    field: "testAddress",
    headerName: "Diag-Adresse",
    width: 250,
  },
  {
    field: "kfn",
    headerName: "KonzernfahrzeugNummer",
    width: 220,
  },
  {
    field: "fn",
    headerName: "FahrgestellNummer",
    width: 220,
  },
  {
    field: "audiPartNumber",
    headerName: "VW/Audi-Teilenummer",
    width: 250,
  },
  {
    field: "hardwarePartNumber",
    headerName: "HardwareteileNummer",
    width: 250,
  },
  {
    field: "hwVersion",
    headerName: "HW-Version",
    width: 150,
  },
  {
    field: "swVersion",
    headerName: "SW-Version",
    width: 150,
  },
  {
    field: "bootloader",
    headerName: "Bootloader",
    width: 110,
  },
  {
    field: "flashTester",
    headerName: "Flashbar mit Tester",
    type: "boolean",
    width: 180,
    renderCell: (params) => {
      if (params.value === null) {
        return "";
      }
      return params.value ? "✓" : "✗";
    }
  },
  {
    field: "keyType",
    headerName: "Schlüsseltyp",
    width: 180,
  },
  {
    field: "timestamp",
    headerName: "Zeitstempel",
    type: "dateTime",
    filterable: false,
    width: 180,
    valueGetter: (value) => value && new Date(value.value),
  },
];
